// Application version configuration
// Reads version from package.json, can be overridden by environment variable REACT_APP_VERSION
import packageJson from '../../package.json';

const packageVersion = process.env.REACT_APP_VERSION || packageJson.version || '1.0.0';

export const APP_VERSION = packageVersion;

